import { atom } from "recoil"
import { Key } from "../EnumKey"

const isUsingLocalStoredAtom = atom({
  key: Key.USINGLOCALSTOREDSTATUS,
  default: true as boolean
})

export default isUsingLocalStoredAtom